import React from "react";

type TwoColumnGridProps = {
  children: React.ReactNode;
  className?: string;
};

export const TwoColumnGrid: React.FC<TwoColumnGridProps> = ({ children, className }) => (
  <div className={[
    "grid grid-cols-1 xl:grid-cols-3 gap-4 xl:gap-6 xl:max-w-6xl mx-auto w-full xl:-mt-4 xl:pt-2",
    className ?? "",
  ].join(" ").trim()}
  >
    {children}
  </div>
);

type MainColumnProps = {
  children: React.ReactNode;
  className?: string;
};

export const MainColumn: React.FC<MainColumnProps> = ({ children, className }) => (
  <div className={[
    "min-w-0 xl:col-span-2 xl:-ml-6",
    className ?? "",
  ].join(" ").trim()}
  >
    {children}
  </div>
);

type RightRailProps = {
  children: React.ReactNode;
  className?: string;
};

export const RightRail: React.FC<RightRailProps> = ({ children, className }) => (
  <div className={[
    "hidden xl:flex flex-col gap-4 w-full min-w-0 max-w-sm xl:max-w-md",
    className ?? "",
  ].join(" ").trim()}
  >
    {children}
  </div>
);